import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {filterGroupVisualStylePopupItemSelected} from './../../../actions/A_Popups';

import template from './../../../templates/PageLayout/Popups/FilterGroupVisualStylePopup.rt';
import {filterGroupVisualStylePopup} from "../../../actions/A_Popups";

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
  filterGroupVisualStyleSelected: style => dispatch(filterGroupVisualStylePopupItemSelected(style)),
  filterGroupVisualStylePopup: (show, style) => dispatch(filterGroupVisualStylePopup(show, style))
});

class FilterGroupVisualStylePopup extends PureComponent {
  render() {
    return template.apply(this);
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterGroupVisualStylePopup);

